import React from "react";
import "./simple-loading.pure.css";
import { Loader } from "@progress/kendo-react-indicators";

/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const SimpleLoading = (props) => {
  return (
    <Loader size="large" type={'infinite-spinner'} style={{ color: '#00A4E0' }} />
  );
};

export { SimpleLoading as default };
